var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-modal',{attrs:{"name":"adv-modal","click-to-close":"","hide-header":"","hide-footer":"","width":_vm.modalWidth}},[_c('a',{attrs:{"href":"https://pinvoice.vn/","target":"_blank"}},[_c('app-carousel',{attrs:{"imgWidth":_vm.imgWidth,"imgHeight":_vm.imgHeight,"items":_vm.items}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04c84968","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/portal-components/invoice/adv-modal.vue
// module id = DaZW
// module chunks = 23